import { EnglishArabicDTO } from "bnsights-control-library"
export class ConfigurationModel
{
      ID:number
      ModifiedBy:string
      Created :any
      Modified :any
      Key:string
      Value:string
      TextValue:string
      BoolValue:boolean
      ScopeId:number
      UserID?:number
      PermissionSetID?:number
      ScopeName:string
      UserName:string
      PermissionSetName:string
      ValidationError:string
      IDEncrypted:string
      ValueType?:number
      ValueSource?:number
      SelectedLookupID?:number
      ValueSourceName :EnglishArabicDTO=new EnglishArabicDTO();
      ValueTypeName :EnglishArabicDTO=new EnglishArabicDTO();
      SourceFunctionName:string
      SourcePartialViewActionName:string
      DevMode:boolean
      DefaultValue:string
      DefaultTextValue:string
      DefaultBoolValue:boolean

}
     